import { getItemLocalStorage } from './getItemLocalStorage.js';

const getConfig = (id) => {
    const configs = getItemLocalStorage('configuracoes');
    if (!configs) {
        return null;
    }
    const search = configs.find(config => config.id === id);
    return search ? search === null || search === void 0 ? void 0 : search.value : null;
};
const getConfigs = (arrId) => {
    const configs = getItemLocalStorage('configuracoes');
    return configs.filter(config => arrId.includes(config.id));
};
const getConfigsArray = (arrId) => {
    const configs = getConfigs(arrId);
    const arrConfig = [];
    configs.forEach(config => {
        arrConfig[config.id] = config.value;
    });
    return arrConfig;
};

export { getConfig, getConfigs, getConfigsArray };
